import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

function updateConsent(granted) {
  try {
    localStorage.setItem("gor_cookie_consent", granted ? "granted" : "denied");
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    const v = granted ? "granted" : "denied";
    window.gtag("consent", "update", {
      ad_storage: v,
      analytics_storage: v,
      ad_user_data: v,
      ad_personalization: v,
    });
  }
}

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let choice = null;
    try {
      choice = localStorage.getItem("gor_cookie_consent");
    } catch {
      /* ignore */
    }
    if (!choice) setShow(true);
  }, []);

  if (!show) return null;

  function decide(granted) {
    updateConsent(granted);
    setShow(false);
  }

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-0 inset-x-0 z-[60] bg-navy-deep text-white border-t border-[#C6A87C]/40"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col lg:flex-row items-start lg:items-center gap-5">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={24} weight="light" className="text-[#C6A87C] flex-shrink-0 mt-0.5" />
          <p className="text-sm text-white/80 leading-relaxed">
            We use cookies and analytics/advertising tools (Google Analytics, Google
            Tag Manager, AdRoll, Shown.io) to understand site usage and improve our
            services. You can accept or decline non-essential cookies. See our{" "}
            <Link to="/privacy" className="text-[#C6A87C] underline underline-offset-2 hover:text-white">
              Privacy Notice
            </Link>
            .
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <Button
            data-testid="cookie-decline"
            onClick={() => decide(false)}
            variant="outline"
            className="rounded-none border-white/40 text-white hover:bg-white hover:text-navy h-11 px-6 bg-transparent"
          >
            Decline
          </Button>
          <Button
            data-testid="cookie-accept"
            onClick={() => decide(true)}
            className="rounded-none bg-[#C6A87C] hover:bg-white text-navy h-11 px-8 font-semibold"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}
